import { OPTION_SELECTOR, SELECTED_OPTION_SELECTOR } from './constants';
import { resolveNextIndexWithLoop } from './helpers';
import { isActivationKey } from './keys';

export class RovingTabIndexGroup {
  static focusSelectedOption = (container) => {
    const selectedOption = container?.querySelector(SELECTED_OPTION_SELECTOR)
      || container?.querySelector(OPTION_SELECTOR);

    selectedOption?.focus();
  };

  constructor(options, onChange, { selectedAttribute = 'aria-checked', selectedClass = null } = {}) {
    this.options = options;
    this.selectedAttribute = selectedAttribute;
    this.selectedClass = selectedClass;
    this.onChange = onChange;
  }

  select = (option) => {
    this.markSelected(option);
    this.onChange(option);
  };

  markSelected = (selectedOption) => {
    this.options.forEach((option) => {
      const isSelected = option === selectedOption;

      if (this.selectedClass) {
        option.classList.toggle(this.selectedClass, isSelected);
      }

      option.setAttribute(this.selectedAttribute, isSelected);
    });

    this.moveTabStopTo(selectedOption);
  };

  moveTabStopTo = (tabbableOption) => {
    this.options.forEach((option) => {
      option.tabIndex = option === tabbableOption ? 0 : -1;
    });
  };

  initializeTabStop = () => {
    const preselectedOption = this.options.find((option) => (
      option.getAttribute(this.selectedAttribute) === 'true'
    ));

    this.moveTabStopTo(preselectedOption || this.options[0]);
  };

  handleKeydown = (event) => {
    const currentIndex = this.options.indexOf(event.currentTarget);
    const nextIndex = resolveNextIndexWithLoop(event, currentIndex, this.options.length);

    if (nextIndex !== null) {
      const nextOption = this.options[nextIndex];

      event.preventDefault();
      nextOption.focus();
      this.select(nextOption);
    } else if (isActivationKey(event)) {
      event.preventDefault();
      this.select(event.currentTarget);
    }
  };
}
